import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fmtNumber' })
export class IndianNumber implements PipeTransform {
  transform(value: number, args: string[]): string {
    return value.toLocaleString('en-IN');
  }
}
